import { ILabels, ILanguage } from "@/apps/StudentExchangeOverviewWidget/models/config-viewmodel";
import { IStudies } from "@/apps/StudentExchangeOverviewWidget/models/studies-viewmodel";

export interface StudentExchangeOverviewWidget {
    loading: boolean
    language: ILanguage
    studies: IStudies
    labels: ILabels
    selectedFilterYear: string
    selectedFilterStudy: string
}

export class WidgetState implements StudentExchangeOverviewWidget {
    loading: boolean = false
    language: ILanguage = ''
    studies: IStudies = []
    labels: ILabels = {
        exchangeOverviewNoDataFound: '',
        overviewHelpInformationHeader: '',
        overviewHelpInformationContent: '',
        buttonRegisterInternship: '',
        buttonRegisterExchange: '',
        headerOverviewType: '',
        headerOverviewDate: '',
        headerOverviewStatus: '',
        buttonExchangeEdit: '',
        buttonExchangeCancel: '',
        buttonExchangeView: '',
        buttonExchangeApplyScholarship: '',
        exchangeFilterText: '',
        selectedYearText: '',
        selectedStudyText: '',
        loadingLabel: '',
        exchangeOverviewSwipeTableText: '',
        exchangeOverviewScholarshipTableColumnDescriptionText: '',
        exchangeOverviewScholarshipRequestTableColumnDescriptionText: ''
    }
    selectedFilterYear: string = ''
    selectedFilterStudy: string = ''
    isModalOpen: Boolean = false
    offset: number = 0
}
